var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSku = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31.000000pt",
    height: "28.000000pt",
    viewBox: "0 0 31.000000 28.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,28.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 195 l0 -85 70 0 70 0 0 -36 c0 -65 36 -98 60 -55 5 11 10 74 10 140 l0 121 -105 0 -105 0 0 -85z m180 35 c0 -18 -7 -20 -75 -20 -68 0 -75 2 -75 20 0 18 7 20 75 20 68 0 75 -2 75 -20z m0 -70 c0 -17 -7 -20 -43 -20 -24 0 -48 -5 -54 -11 -14 -14 -53 10 -53 33 0 16 10 18 75 18 68 0 75 -2 75 -20z",
    fill: "#484b52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 55 c0 -8 9 -24 20 -35 16 -16 33 -20 91 -20 61 0 70 2 65 16 -3 9 -6 24 -6 35 0 17 -8 19 -85 19 -69 0 -85 -3 -85 -15z",
    fill: "#484b52"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSku, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sku.b142e9fc.svg";
export { ForwardRef as ReactComponent };